import styled from 'styled-components';
import { Label } from '@riac/design-system';
import { ILabelText } from 'src/components/Input/Input.i';

export const WrappedInput = styled.input`
  &:not([type='submit']) {  /*Weird specificity, maybe needs changed in global?*/
    flex: 1;
    margin-bottom: 0;
  }
`;

export const RequiredStar = styled.span`
  font-weight: 800;
  line-height: 0;
  color: rgba(255, 255, 255, 0.95);
`;

export const AddonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`;

export const LabelContainer = styled(Label)`
  position: relative;
  margin-top: 10px;
`;

export const LabelText = styled.span<ILabelText>`
  position: absolute;
  top: 7px;
  left: 10px;
  font-size: 2rem;
  transition: all 0.3s ease-in-out;
  cursor: text;

  ${(props) => props.hasFocus && `
    top: -20px;
    left: 0;
    font-size: 1.4rem;
    cursor: default;
  `}
`;
